/**
 * キャンバスのアニメーションを録画してWebM動画としてダウンロードするユーティリティ
 */

export class CanvasRecorder {
  constructor(canvasElement, onProgress, onComplete) {
    this.canvas = canvasElement;
    this.onProgress = onProgress;
    this.onComplete = onComplete;
    this.isRecording = false;
    this.mediaRecorder = null;
    this.recordedChunks = [];
  }

  setCanvas(canvasElement) {
    this.canvas = canvasElement;
  }

  startRecord(durationMs = 5000) {
    if (this.isRecording || !this.canvas) return;

    // キャンバスのストリームを取得 (30fps)
    const stream = this.canvas.captureStream ? this.canvas.captureStream(30) : null;
    if (!stream) {
      alert('お使いのブラウザはCanvas録画に対応していません。');
      return;
    }

    this.recordedChunks = [];
    this.isRecording = true;

    // サポートされているMIMEタイプを検出
    const mimeTypes = [
      'video/webm;codecs=vp9',
      'video/webm;codecs=vp8',
      'video/webm',
      'video/mp4'
    ];
    let selectedMime = '';
    for (const type of mimeTypes) {
      if (MediaRecorder.isTypeSupported(type)) {
        selectedMime = type;
        break;
      }
    }

    try {
      this.mediaRecorder = new MediaRecorder(stream, selectedMime ? { mimeType: selectedMime } : {});
    } catch (e) {
      this.mediaRecorder = new MediaRecorder(stream);
    }

    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data && event.data.size > 0) {
        this.recordedChunks.push(event.data);
      }
    };

    this.mediaRecorder.onstop = () => {
      const blob = new Blob(this.recordedChunks, { type: selectedMime || 'video/webm' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `isekai-joucho-art-${Date.now()}.webm`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      this.isRecording = false;
      if (this.onComplete) this.onComplete();
    };

    this.mediaRecorder.start();
    if (this.onProgress) this.onProgress(true);

    // 指定時間後に停止
    setTimeout(() => {
      if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
        this.mediaRecorder.stop();
      }
    }, durationMs);
  }
}
